module.exports = __webpack_public_path__ + "img/h-square.9576a77e.svg";